import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "component-wrapper" }
const _hoisted_2 = { class: "xpage-top" }
const _hoisted_3 = { class: "section-left xpage-top-col1" }
const _hoisted_4 = { class: "xpage-top-profile" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "status-container" }
const _hoisted_8 = { class: "application-actions" }
const _hoisted_9 = { class: "xpage-top-details-status" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "section-right" }
const _hoisted_13 = {
  class: "xpage-top-row",
  id: "middle"
}
const _hoisted_14 = { class: "xpage-top-column" }
const _hoisted_15 = { class: "xpage-top-col2" }
const _hoisted_16 = { class: "loan-data" }
const _hoisted_17 = { class: "loan-info" }
const _hoisted_18 = { class: "summary-mid-value" }
const _hoisted_19 = { class: "summary-low-value" }
const _hoisted_20 = { class: "xpage-top-column" }
const _hoisted_21 = { class: "xpage-top-col3" }
const _hoisted_22 = { class: "loan-data" }
const _hoisted_23 = { class: "loan-info" }
const _hoisted_24 = { class: "summary-mid-value" }
const _hoisted_25 = { class: "summary-low-value" }
const _hoisted_26 = {
  class: "xpage-top-row",
  id: "stepper"
}
const _hoisted_27 = { class: "xpage-top-right" }
const _hoisted_28 = { class: "stepper" }
const _hoisted_29 = { class: "step-icons" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "step-content" }
const _hoisted_32 = { class: "stat" }
const _hoisted_33 = {
  key: 0,
  class: "step-arrow"
}

import { ref, onMounted, computed, watchEffect } from "vue";
import { storeToRefs } from "pinia";
import { useApplicationStore } from "@/store/store/applicationVMStore";
import { Permissions, PermissionLevels } from "@/models/permissions";
import PermissionsWrapper from "@/components/wrappers/PermissionsWrapper.vue";
import PermissionsButton from "@/components/wrappers/PermissionsButton.vue";
import ApplicationStatus from "@/components/v2/application/ApplicationStatus.vue";
import CancellationModal from "@/components/v2/application/refi/CancellationModal.vue";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/vue/24/solid";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { usePayoffTabStore } from "@/store/store/payoffTabStore";
import { useApplicationDetails } from "@/composables/application/useApplicationDetails";

interface StatItem {
  name: string;
  status?: string;
  date?: string;
  step?: string | number;
}

interface ErrorResponseData {
  message?: string;
  errors?: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailsSLR',
  setup(__props) {

const applicationStore = useApplicationStore();
const payoffTabStore = usePayoffTabStore();

const router = useRouter();
const { summary } = storeToRefs(applicationStore);

const currentStepIndex = ref(-1);
const showCancelModal = ref(false);
const mobileHidden = ref(true);
const store = useStore();

const rightToCancel = applicationStore.viewModel.rightToCancelDisplay;

const submittedDisplay = applicationStore.viewModel.submittedDisplay;

const esignEnvelopeCreatedDisplay =
  applicationStore.viewModel.esignEnvelopeCreatedDisplay;

const esignEnvelopeSignedDisplay =
  applicationStore.viewModel.esignEnvelopeSignedDisplay;

const anticipatedDisbursementDate =
  applicationStore.viewModel.anticipatedDibursementDisplay;

const stats: StatItem[] = [
  { name: "Application<br>Submitted", date: submittedDisplay },
  { name: "E-Sign Envelope<br>Created", date: esignEnvelopeCreatedDisplay },
  { name: "E-Sign Envelope<br>Signed", date: esignEnvelopeSignedDisplay },
  { name: "Right to Cancel<br>End Date", date: rightToCancel },
  {
    name: "Anticipated<br>Disbursement Date",
    date: anticipatedDisbursementDate,
  },
];

const { moveToLoanService } = useApplicationDetails();

const showMoveToLoanService = computed(() => {
  return (
    applicationStore.viewModel.statusName === "Complete" &&
    !applicationStore.viewModel.loanId
  );
});

const toggleIconClass = computed(() =>
  mobileHidden.value ? "icon-down-open-big" : "icon-up-open-big"
);

const toggleApplicationDetailsMobile = () => {
  mobileHidden.value = !mobileHidden.value;
};

const updateApplication = async () => {
  const referenceId = applicationStore.referenceId;
  await Promise.all([
    applicationStore.getApplication(referenceId),
    applicationStore.getApplicationSummary(referenceId),
    applicationStore.getApplicationComments(referenceId),
  ]);
};

function getStepClass(index: number): string {
  const RTC_STEP_INDEX = 3;
  const DISBURSEMENT_STEP_INDEX = 4;

  const isRTCDatePassed = () => {
    const rtcDate = stats[RTC_STEP_INDEX].date;
    if (!rtcDate || rtcDate === "N/A") return false;
    return new Date(rtcDate) < new Date();
  };

  if (currentStepIndex.value === -1) {
    for (let i = 0; i < stats.length; i++) {
      if (!stats[i].date || stats[i].date === "N/A") {
        currentStepIndex.value = i;
        break;
      }
    }
    if (currentStepIndex.value === -1) {
      currentStepIndex.value = stats.length - 1;
    }
  }

  if (index === RTC_STEP_INDEX) {
    if (stats[index].date && stats[index].date !== "N/A") {
      return isRTCDatePassed() ? "step-complete" : "step-active";
    }
  }

  if (index === DISBURSEMENT_STEP_INDEX) {
    if (stats[index].date && stats[index].date !== "N/A" && isRTCDatePassed()) {
      return "step-complete";
    }
    return "step-na";
  }

  if (
    index < RTC_STEP_INDEX &&
    stats[index].date &&
    stats[index].date !== "N/A"
  ) {
    return "step-complete";
  }

  if (index === currentStepIndex.value) {
    return "step-active";
  }

  return "step-na";
}

onMounted(() => {
  for (let i = 0; i < stats.length; i++) {
    if (!stats[i].date || stats[i].date === "N/A") {
      currentStepIndex.value = i;
      break;
    }
  }
  if (currentStepIndex.value === -1) {
    currentStepIndex.value = stats.length - 1;
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_title_overflow = _resolveDirective("title-overflow")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("h2", {
            class: "applicant-name fullname-wrap text-overflow-ellipsis",
            style: {"display":"block !important"},
            title: _unref(summary).primaryApplicantFullName
          }, [
            _createTextVNode(_toDisplayString(_unref(summary).primaryApplicantFullName), 1)
          ], 8, _hoisted_5)), [
            [_directive_title_overflow]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("h3", {
            class: "lender-name",
            title: _unref(summary).lenderName
          }, [
            _createTextVNode(_toDisplayString(_unref(summary).lenderName), 1)
          ], 8, _hoisted_6)), [
            [_directive_title_overflow]
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(PermissionsWrapper, {
                showDisabledIfNotVisible: true,
                permissionIds: [_unref(Permissions).ProgramConfiguration],
                permissionLevel: _unref(PermissionLevels).Update
              }, {
                default: _withCtx(() => [
                  _createVNode(ApplicationStatus)
                ]),
                _: 1
              }, 8, ["permissionIds", "permissionLevel"]),
              (_unref(summary).isRightToCancel)
                ? (_openBlock(), _createBlock(PermissionsButton, {
                    key: 0,
                    permissionIds: [_unref(Permissions).RightToCancel],
                    permissionLevel: _unref(PermissionLevels).Update,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showCancelModal.value = true)),
                    class: "cancel-application-btn"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" Cancel Application ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["permissionIds", "permissionLevel"]))
                : _createCommentVNode("", true),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
                (showMoveToLoanService.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "submit",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(moveToLoanService)(true))),
                      class: "loan-service-btn"
                    }, [
                      (showMoveToLoanService.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Move To Loan Service »"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, "Processing..."))
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_auto_animate, { ..._ctx.$animate, duration: 100 }]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "summary-top-value" }, "Loan Amount", -1)),
                  _createElementVNode("h3", _hoisted_18, _toDisplayString(_unref(summary).loanAmountDisplay), 1),
                  _createElementVNode("h4", _hoisted_19, " Max Approved: " + _toDisplayString(_unref(applicationStore).summary.maxApprovedLimitDisplay), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "summary-top-value" }, "Interest Rate", -1)),
                  _createElementVNode("h3", _hoisted_24, _toDisplayString(_unref(summary).rate), 1),
                  _createElementVNode("h4", _hoisted_25, _toDisplayString(_unref(summary).rateTypeName), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stats, (item, index) => {
                return _createElementVNode("div", {
                  key: item.name,
                  class: _normalizeClass(['step', getStepClass(index)])
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    (getStepClass(index) === 'step-complete')
                      ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                          key: 0,
                          class: "step-icon"
                        }))
                      : (getStepClass(index) === 'step-active')
                        ? (_openBlock(), _createBlock(_unref(QuestionMarkCircleIcon), {
                            key: 1,
                            class: "step-icon"
                          }))
                        : (_openBlock(), _createBlock(_unref(ExclamationCircleIcon), {
                            key: 2,
                            class: "step-icon"
                          }))
                  ]),
                  _createElementVNode("span", {
                    class: "step-title",
                    innerHTML: item.name
                  }, null, 8, _hoisted_30),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, _toDisplayString(item.date), 1)
                  ]),
                  (index < stats.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        (_openBlock(), _createElementBlock("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: _normalizeClass(["arrow-icon", ['arrow-na', { 'arrow-na': item.date === 'N/A' }]]),
                          viewBox: "0 0 20 20",
                          fill: "currentColor"
                        }, [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("path", {
                            fill: "currentColor",
                            d: "M11 16H3V8h8V2l10 10l-10 10zm2-9v3H5v4h8v3l5-5z"
                          }, null, -1)
                        ]))], 2))
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              }), 64))
            ])
          ])
        ])
      ]),
      (showCancelModal.value)
        ? (_openBlock(), _createBlock(CancellationModal, {
            key: 0,
            onUpdate: updateApplication,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (showCancelModal.value = $event))
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})